<template>
  <div class="py-2 my-2 help-container">
    <h1 class="separator py-4">EXPORT</h1>
    <span class="banner py-3 mb-4">
      <div>This option will enable you to export your Working Draft information to excel with formulas or export in import-ready CSV format.</div>
      <div>Your first choice will be which format you would like: EXCEL FORMAT or CSV FORMAT.</div>
      <div>If you select CSV FORMAT, you will click EXPORT to create the file.</div>
      <div>If you select EXCEL FORMAT, you can select what options should be exported:</div>
    </span>

    <!--Help Sections-->
    <v-expansion-panels v-model="openSectionInternal">
      <v-expansion-panel>
        <v-expansion-panel-header :color="getSectionColorFor(0)">
          <v-icon small class="icon" slot="actions" :color="getIconColorFor(0)">$vuetify.icons.expand</v-icon>
          <span class="header pl-3"><strong>Working Draft</strong></span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="help-content">
          <ul>
            <li>Include Calculations Column?</li>
            <li class="no-bullet">
              <ul>
                <li>If this is selected an additional column will be exported that contains the two most recent calculations that were performed for each GL Account.</li>
                <li>If no calculations were performed, this column will be blank.</li>
                <li>Note: The numbers may have been adjusted after the calculation was run.</li>
              </ul>
            </li>
            <li>Include Assumptions Column?</li>
            <li class="no-bullet">
              <ul>
                <li>If this is selected an additional column will be exported that contains the Assumption statement for this GL Account. The Assumption may be edited by clicking either the Assumptions icon or clicking the ellipsis drop-down and selecting Add Assumption or View Calculation menu option.</li>
              </ul>
            </li>
            <li>Include Other (Balance Sheet) Accounts?</li>
            <li class="no-bullet">
              <ul>
                <li>If this is selected, your export file will include any of your Balance Sheet accounts that you have budgeted.</li>
              </ul>
            </li>
            <li>Hide Zero Only Rows?</li>
            <li class="no-bullet">
              <ul>
                <li>If this is selected, any row that has no budgeted numbers and has no prior year actual numbers will be removed.</li>
                <li>Note: This will not be a hidden row. The row will not be in the spreadsheet at all.</li>
              </ul>
            </li>
            <li>Display Working Rows?</li>
            <li class="no-bullet">
              <ul>
                <li>If this is selected, any GL Account which has Working Rows will be exported with the Working Row information.</li>
                <li>Note: These rows will not be part of the excel math totals. Only the GL Account budget row will be part of the totals.</li>
              </ul>
            </li>
          </ul>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header :color="getSectionColorFor(1)">
          <v-icon small class="icon" slot="actions" :color="getIconColorFor(1)">$vuetify.icons.expand</v-icon>
          <span class="header pl-3"><strong>Additional Options</strong></span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="help-content">
          <ul>
            <li>Include Market Rent & Occupancy Worksheets?</li>
            <li class="no-bullet">
              <ul>
                <li>If this is selected, it will create nine additional tabs within the exported spreadsheet that replicate the data on the Market Rent and Occupancy top summary sections as well as for each tab.</li>
                <li>These tabs will have no formulas.</li>
              </ul>
            </li>
            <li>Include Settings?</li>
            <li class="no-bullet">
              <ul>
                <li>If this is selected, it will add a new tab that will display the settings that were selected for the budget.</li>
              </ul>
            </li>
          </ul>
          <img src="../../assets/help/export1.png" />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel readonly>
        <v-expansion-panel-header>
          <v-icon slot="actions"></v-icon>
          <span class="black--text pointer">Prefer to watch a video? <a @click="openExternalTopic('BudgetsPro Export Budgets')">Click Here</a></span>
        </v-expansion-panel-header>
      </v-expansion-panel>
      <v-expansion-panel readonly>
        <v-expansion-panel-header>
          <v-icon slot="actions"></v-icon>
          <span class="black--text pointer">Want to see all BudgetsPro help articles? <a @click="openExternalTopic('BudgetsPro')">Click Here</a></span>
        </v-expansion-panel-header>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import HelpMixin from '@/mixins/Help.js'
  export default {
    name: 'ExportWorkingDraftHelp',
    mixins: [HelpMixin]
  }
</script>

<style lang="scss" scoped>
  .no-bullet {
    list-style-type: none;
  }
  .icon {
      order: 0;
  }
  .header {
      order: 1;
  }
  img {
    max-width: 650px;
  }
  img.small {
    width: 35px;
  }
  .help-container {
      border-bottom: 1px solid var(--v-resGrey-lighten1)
  }
  .help-content div,
  .help-content li {
      margin-top:10px !important;
      margin-bottom:10px !important;
  }
  .banner {
    text-align: center;
    background-color: var(--v-resGrey-lighten1);
    display: block;
  }
  .pointer {
      cursor: pointer !important;
  }
  .separator {
    display: flex;
    align-items: center;
    text-align: center;
  }
  .separator::before,
  .separator::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid var(--v-resGrey-darken1);
  }

  .separator:not(:empty)::before {
    margin-right: .25em;
  }

.separator:not(:empty)::after {
  margin-left: .25em;
}
</style>
